module.exports = __webpack_public_path__ + "img/tienda.6f5945eb.png";